import { Directive, AfterViewInit, OnDestroy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'input[numbersOnly]',
  standalone: true,
})
export class NumbersOnlyDirective implements AfterViewInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();

  constructor(private readonly ngControl: NgControl) {}

  ngAfterViewInit(): void {
    const changesSubs = this.ngControl.valueChanges
      .subscribe((value: string): void => {
        const initialValue = typeof value === 'string' ? value.replace(/[^0-9]/g, '') : '';

        if (value !== initialValue) {
          this.ngControl.control?.setValue(initialValue, { emitEvent: false });
        }
      });

    this.subscriptions.add(changesSubs);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}

// todo: numbers-format.directive not standalone and declared in reason-box dialog. Check it.
